<template>
  <div>
    <Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
      <template #action>
        <div class="main" v-if="target&&open">
          <div class="flex justify-between m-2">
            <div class="font-bold text-blue-800">
              {{ target.site }}
              <p class="text-xs text-red-700">※何も表示されない場合、マスタ設定済みかご確認ください。</p>
            </div>
            
            <div class="text-lg font-bold text-blue-700 w-fit mx-auto">ドラッグ＆ドロップで清掃を振替できます</div>
            <div class="">
              <!-- 閉じる -->
              <SecondaryButton
                text="閉じる"
                class="border-gray-700 px-6"
                @click="closed()"
              ></SecondaryButton>
            </div>
          </div>

          <div class="flex justify-center">
            <Icon
              iconName="ChevronLeft"
              :clickable="false"
              class="text-gray-700 hover:text-blue-600 cursor-pointer w-10 h-8 self-center"
              @click.native="viewRender(-1)"
            />
            <div class="font-bold self-center">
              {{ title }}
            </div>
            <Icon
              iconName="ChevronRight"
              :clickable="false"
              class="text-gray-700 hover:text-blue-600 cursor-pointer w-10 h-8 self-center"
              @click.native="viewRender(1)"
            />
          </div>

          <full-calendar
            ref="calendar"
            id="calendar"
            :events="events"
            :config="config"
            @view-render="viewRender"
          ></full-calendar>
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import Icon from '@components/Icon.vue'
import Modal from '@components/Modal.vue'
import { FullCalendar } from 'vue-full-calendar'
import SecondaryButton from '@components/SecondaryButton.vue'
import * as backend from '@libs/backend'
import * as logManager from '@managers/logManager'
import 'fullcalendar/dist/fullcalendar.css'
import * as moment from 'moment'
import * as dialogs from '@libs/dialogs'
import jQuery from 'jquery'

window.$ = window.jQuery = jQuery

export default {
  components: {
    Icon,
    FullCalendar,
    Modal,
    SecondaryButton,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    target: {
      type: Object
    },
    // 稼働から開いた
    operation: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      // 祝日
      holidays: [],
      // 表示月タイトル
      title: '',
      // 表示開始日
      start: null,
      // 表示データ（title, start, end(任意), allDay, color, backgroundColor, textColor, className）
      events: [],
      // 設定
      config: {
        // 初期表示：月間
        defaultView: 'month',
        // 日本語
        locale: 'ja',
        // ドラッグOK
        editable: true,
        // リサイズNG
        eventDurationEditable: false,
        eventClick(event, jsEvent) {
          // クリックを無効化したいので、デフォルト動作をキャンセル
          jsEvent.preventDefault()
          return false
        },

        header: {
          left: '',
          center: '',
          right: ''             // ← 切り替えボタンを消す
        },
        contentHeight: 'auto', // ← 高さを自動調整！
        height: "auto",
      },
    }
  },

  created() {
    // ドロップイベント
    this.config.eventDrop = async (e, delta, revertFunc) => {
      // ゴミ出しはNG
      if (e.title.indexOf('ゴミ') > -1) {
        revertFunc()
        return
      }
      // 日付が変わっていないなら何もしない
      if (!e.data || e.data.day == moment(e.start).format('YYYY-MM-DD')) {
        revertFunc()
        return
      }
      // 清掃がない場合はNG
      if (!e.data || !e.data.isClean) {
        await dialogs.showErrorDialog('清掃なし', '振替できるのは「清掃」です。')
        revertFunc()
        return
      }
      // 完了しているのはNG
      if (e.data.cleanDoneTime) {
        await dialogs.showErrorDialog('完了済み', '完了しているので振替できません。')
        revertFunc()
        return
      }
      // 本日より前の日付だったらNG
      const today = Number(moment().format('YYYYMMDD'))
      const target = Number(moment(e.start).format('YYYYMMDD'))
      if (today > target) {
        await dialogs.showErrorDialog('過去日のため変更不可', '本日以降にしてください。')
        revertFunc()
        return
      }
      // 同じ月のみ可能
      if ((e.data.day).slice(0, 7) != moment(e.start).format('YYYY-MM')) {
        await dialogs.showErrorDialog('同月内のみ可能', '同じ月のみ振替可能です。違う月には振替できません。')
        revertFunc()
        return
      }

      const daySt = moment(e.start).format('YYYY-MM-DD')
      // 移動先の確認
      const toRow = this.events.find((row) => {
        return row.start == daySt
      })
      // 日曜に移動はNG
      if (e.start.day() === 0) {
        await dialogs.showErrorDialog('日曜はNG', '日曜に振替はできません。')
        revertFunc()
        return
      }

      // 祝日に移動はNG
      if (this.holidays && this.holidays.includes(daySt)) {
        await dialogs.showErrorDialog('祝日はNG', '祝日に振替はできません。')
        revertFunc()
        return
      }
      

      // 清掃有に移動はNG
      if (toRow && toRow.data.isClean) {
        await dialogs.showErrorDialog('すでに清掃あり', '清掃がある日に振替はできません。')
        revertFunc()
        return
      }

      const log = await dialogs.showConfirmDialog('保存しますか？', '予定を変更してよろしいですか？')
      if (log != 'YES') {
        revertFunc()
        return
      }
      await this.saveData(e)
    }
  },

  watch: {
    async open() {
      if (this.open) {
        this.events = []
        this.start = moment().format('YYYY-MM-01')
        this.title = moment().format('YYYY年M月')
        // 祝日日を取得
        this.getHolidays()
        await this.getData()
      }
    },
  },

  methods: {
    /**
     * カレンダーデータ取得
     */
    async getData() {
      if (!this.open) {
        return
      }
      this.events = []
      this.loading = true
      if (this.start) {
        // カレンダー情報取得
        const res = await backend.postData('rls/getSchedule', { startDate: this.start, siteCode: this.target.siteCode, title: 'calendar' })
        if (res.data.data && res.data.data.length) {
          const trash = []
          const clean = []
          for (let i = 0; i < res.data.data.length; i++) {
            const row = res.data.data[i]
            // ゴミあり
            if (row.isTrash) {
              // 未完了カラー
              let color = '#2b9319'
              let textColor = ''

              // 完了
              if (row.trashDoneTime) {
                color = '#d6f0daff'
                textColor = '#085714ff'
              }
              // スポット
              let spot = ''
              if (row.isTrashSpot) {
                spot = '（スポット）'
              }
              trash.push({
                title: 'ゴミ' + spot,
                start: row.day,
                allDay: true,
                color,
                textColor,
                data: { ...row }
              })
            }

            // 清掃あり
            if (row.isClean) {
              // 未完了カラー
              let color = '#1404aaff'
              let textColor = ''

              // 完了
              if (row.cleanDoneTime) {
                color = '#b8a5ecff'
                textColor = '#233b66ff'
              }
              // タイトル
              let title = '清掃'
              if (row.exchange) {
                title += '（' + row.exchange + 'の振替）'
              }
              if (row.isCleanSpot) {
                title += '（スポット）'
              }
              clean.push({
                title,
                start: row.day,
                allDay: true,
                color,
                textColor,
                data: { ...row }
              })
            }
          }
          this.events = trash.concat(clean)
        } else {
          this.events = []
          if (res.data.data.noData) {
            alert('まだ予定が生成されていません。予定を確認したい場合は管理者権限を持っているユーザーにご連絡ください。\r\n（夜間に自動で4ヶ月先までの予定が保存されます）')
          }
        }
      }
      this.refreshEvents()
      this.loading = false
    },

    /**
     * 該当月の祝日を取得
     */
    async getHolidays() {
      if (!this.open) {
        this.holidays = []
        return
      }
      if (!this.start) {
        this.holidays = []
        return
      }
      const month = this.start.substring(0, 7)
      const res = await backend.searchData('rls/getHolidaysByMonth', { month })
      this.holidays = res.data.data
    },

    /**
     * 切替
     */
    viewRender(add) {
      const start = moment(this.start + 'T00:00:00').add(add, 'months')
      this.start = start.format('YYYY-MM-01')
      this.title = start.format('YYYY年M月')

      const $calendar = this.$refs.calendar.$el
      // eslint-disable-next-line no-undef
      $($calendar).fullCalendar('gotoDate', this.start)

      // 祝日を取得
      this.getHolidays()
      this.getData()
    },

    /**
     * データ保存
     */
    async saveData(e) {
      this.loading = true
      const toDate = moment(e.start).format('YYYY-MM-DD')

      // // すでに振替られている場合は既存データを削除
      // await backend.searchData('rls/getExchange', { toDate, siteCode: this.target.siteCode })

      let fromDate = e.data.day
      const insertUser = this.$store.getters.user.id

      // すでに何度も振り替えている場合、もともとの日
      if (e.data.exchange) {
        fromDate = e.data.exchange
      }

      // 巡回参照エラーが出るため、保存するデータを成型
      const saveData = {
        siteCode: this.target.siteCode,
        toDate,
        fromDate,
        insertUser,
      }
      try {
        await backend.postData('rls/saveExchange', saveData)
        this.loading = false

				// ログ登録
				logManager.recordingByRegist(
					this,
					true,
					'RLS振替',
          `${this.target.site}を${fromDate}から${toDate}へ振替`
				)

        await dialogs.showSuccessDialog('保存完了', '振替登録完了しました。')
        if (this.operation) {
          this.$emit('getData')
        }
      } catch (error) {
        this.loading = false
        alert('保存できませんでした。再度操作をお願いします。')
      }
      this.getData()
    },

    /**
     * 再描画
     */
    refreshEvents() {
      this.$refs.calendar.$emit('refetch-events')
    },

    /**
     * 初期化
     */
    closed() {
      this.loading = false
      // 表示データ
      this.events = []
      this.start = null
      this.holidays = []
      // this.refreshEvents()
      this.$emit('closed')
    },
  }
}
</script>
<style scoped>

#calendar >>> table > thead > tr > td > .fc-row {
  margin-right: 0px !important;
}

#calendar >>> table > tbody > tr > .fc-widget-content > .fc-scroller {
  overflow: hidden !important;
}
</style>